// test/TestToken.sol (prome-ctf-contracts) — the beta collateral. faucet() is a
// PUBLIC self-mint that only exists on the test token; mainnet collaterals have
// no such function, so every consumer must gate on FAUCET_ENABLED.
export const testTokenAbi = [
  {
    type: 'function',
    name: 'faucet',
    stateMutability: 'nonpayable',
    inputs: [{ name: 'amount', type: 'uint256' }],
    outputs: [],
  },
] as const;
